import {fetchRemoteResult} from '../../../../../../Api/api-util';

const getDataFromEndpoint = (endpoint) => {

    const errorMsg = 'Please make sure response from api contains two arrays named data and types.'

    return new Promise((resolve, reject) => {
        fetchRemoteResult(endpoint).then(
            (value) => {
                if(value && value.types && value.data) {
                    if(Array.isArray(value.types) && Array.isArray(value.data)) {
                        resolve({
                            types: value.types,
                            data: value.data
                        });
                    } else {
                        console.error(errorMsg);
                        reject(errorMsg);
                    }
                } else {
                    console.error(errorMsg);
                    reject(errorMsg);
                }
            },
            (error) => {
                console.error(error);
                reject(error);
            }
        );
    });
};

export default {
    getDataFromEndpoint
};